<template>

  <div>
    <!--弹窗模块-->

    <!-- 弹窗 -->
    <!--    选中普通素材弹窗-->
    <el-dialog
      title="搭建配置"
      :visible.sync="countdialogVisible"
      width="500px"
      class="custom-dialog"
    >
      <el-form
        label-position="left"
        label-width="180px"
        :model="countformData"
      >
        <!-- 普通素材输入 -->
        <el-form-item label="单账户普通素材搭建数:">
          <el-input-number
            v-model="countformData.normalCount"
            :min="0"
            controls-position="right"
            placeholder="请输入数量"
            class="full-width-input"
          ></el-input-number>
        </el-form-item>

        <!-- 撞审素材输入 -->
        <el-form-item label="撞审素材搭建数:">
          <el-input-number
            v-model="countformData.reviewCount"
            :min="0"
            controls-position="right"
            placeholder="请输入数量"
            class="full-width-input"
          ></el-input-number>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="countdialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="GetPlan"
          class="confirm-btn"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 全屏弹窗 -->
    <template>
      <el-dialog
        :visible.sync="showVue2"
        fullscreen
        :show-close="false"
        custom-class="fullscreen-dialog"
      >
        <!-- 自定义标题栏 -->
        <template #title>
          <div class="dialog-header">
            <span>关闭按钮</span>
            <el-button
              type="danger"
              class="close-btn"
              icon="el-icon-close"
              @click.stop="showVue2 = false"
              circle
            ></el-button>
          </div>
        </template>

        <!-- 内容容器 -->
        <div class="dialog-content-wrapper">
          <Vue2 @click.stop="showVue2 = false" />
        </div>
      </el-dialog>
    </template>
    <el-container  style="height: 2500px">

      <el-main style="height: 1000px">
        <!--          搭建计划代码-->
        <el-card class="" style="padding: 20px;height: 220%;width: 55%">


          <div slot="header" class="clearfix">
            <div style="margin-bottom: 10px">
              <el-descriptions class="margin-top" title="微驰搭建平台" :column="3"  >
                <template slot="extra">
                  <el-button type="primary" @click="countdialogVisible = true"  size="small">批量搭建</el-button>
                  <!--                      <el-button type="primary" @click="getVideoFM"  size="small">ces</el-button>-->
                  <!--                      <el-button type="primary" @click.stop="showVue2 = true" size="small">选择素材</el-button>-->
                  <!-- 动态渲染 Vue2 组件 -->

                  <!--                      <el-button type="primary" v-on:click="zsclearfile"  size="small">重置撞审素材</el-button>-->

                </template>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    姓名
                  </template>
                  <div class="block">
                    <el-select v-model="username"  filterable placeholder="请选择" @change="GetRo">
                      <el-option
                        v-for="(items,i) in listname"
                        :key="i"
                        :value="items.username"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-mobile-phone"></i>
                    登录二代
                  </template>
                  微驰
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    账户列表
                  </template>

                  <el-select v-model="towName" filterable placeholder="请选择" @change="findIds">
                    <el-option
                      v-for="(items,i) in two"
                      :key="i"
                      :value="items.twoname"
                    >
                    </el-option>
                  </el-select>

                </el-descriptions-item>



                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-office-building"></i>
                    广告主账户列表
                  </template>
                  <!--            <el-select v-model="idsname" placeholder="请选择">-->
                  <!--              <el-option-->
                  <!--                v-for="(items,i) in idsList"-->
                  <!--                :key="i"-->
                  <!--                :value="items.idsname">-->
                  <!--              </el-option>-->
                  <!--            </el-select>-->
                  <el-tag :key="i" v-for="(item,i) in idsList">{{item.idsname}}</el-tag>
                  <el-cascader
                    v-model="erjihangye"
                    :options="options5"
                    filterable
                  ></el-cascader>
                </el-descriptions-item>
              </el-descriptions>

              <br>
              <!-- 查询按钮 -->


              <div style="float: left">
                <el-select v-model="selectedCategoryName" placeholder="请选择分类" @change="handleCategoryChange" style="width: 200px; margin-right: 10px;">
                  <el-option
                    v-for="category in categories"
                    :key="category.categoryId"
                    :label="category.categoryName"
                    :value="category.categoryName"
                  ></el-option>
                </el-select>
                <!-- 查询按钮 -->
                <el-button type="primary" @click="handleQuery">添加商品库</el-button>
                <el-button type="danger" @click="clearShangPing">清空商品数据</el-button>
                <!-- 判断list是否为空，若不为空则显示选择框 -->
                <el-select v-if="categoryList.length > 0"  v-model="categoryName"  @change="CategorySelectHandle" placeholder="请选择" style="width: 200px; margin-right: 10px;">

                  <el-option
                    v-for="item in categoryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>





            </div>
            <br>


            <el-form label-position="left" :model="formLabelAlign">
              <el-form-item label="计划名称:" style="margin-bottom: 8px; text-align: left;">
                <el-input
                  v-model="formLabelAlign.name"
                  style="width: 200px; text-align: left;">
                </el-input>
              </el-form-item>
              <el-form-item label="计划预算:" style="margin-bottom: 8px;text-align: left;">
                <el-input
                  placeholder="不填代表不限"
                  v-model="formLabelAlign.dailyBudget"
                  style="width: 200px; text-align: left;">
                </el-input>
              </el-form-item>
              <el-form-item label="推广目标" style="margin-bottom: 8px; text-align: left;">
                <el-radio-group v-model="beSelectAdType" style="text-align: left;">
                  <el-radio-button
                    v-for="item in adTypeList"
                    :key="item.value"
                    :label="item.value"
                    style="">
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="投放渠道:" style="margin-bottom: 8px; text-align: left;">
                <el-radio-group v-model="formLabelAlign.mediaType" style="text-align: left;">
                  <el-radio-button
                    v-for="item in option1"
                    :key="item.value"
                    :label="item.value"
                    style="">
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item style="margin-bottom: 8px; text-align: left;">
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: 20px; display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">计划开关</span>
                    <el-switch
                      v-model="flag"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <div style="margin-right: 20px; display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">最新计划</span>
                    <el-switch
                      v-model="newplanflag"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">微信关注</span>
                    <el-switch
                      v-model="isguanz"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                </div>
              </el-form-item>
            </el-form>

            <!-- 第二个卡片内容 -->
            <el-form label-position="right" :model="formLabelAlign1">
              <el-form-item label="转化目标:"   style="text-align: left;">
                <el-radio-group
                  v-model="formLabelAlign1.cvType"
                  style="text-align: left;"
                >
                  <el-radio-button
                    v-for="item1 in options3"
                    :key="item1.value"
                    :label="item1.value"

                  >
                    {{ item1.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="二阶出价:" style="margin-top: 20px;text-align: left;">
                <el-tag> 是否使用最新广告组出价</el-tag>
                <el-switch
                  v-model="isoldgroupprice"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
                <el-input style="width: 100px;" v-model="formLabelAlign1.ocpxPrice"></el-input>元
              </el-form-item>
              <div style="display: flex; align-items: center; gap: 8px">
                <el-tag style="flex-shrink:0; text-align: right; margin: 0">
                  人群包id(小写逗号分开):
                </el-tag>
                <el-input
                  v-model="customList2"
                  style="width: 200px;"
                  size="small">
                </el-input>
              </div>
              <br>
              <div style="display: flex; align-items: center; gap: 8px">
                <el-tag
                  style="flex-shrink:0; text-align: right; margin: 0">
                  排除人群包id(小写逗号分开):
                </el-tag>
                <el-input
                  v-model="customListpc"
                  style="width: 200px;"
                  size="small">
                </el-input>
              </div>
              <el-form-item label="投放时间段:">
                <div class="time-range-container">
                  <div v-for="(range, index) in timeRanges" :key="index" class="time-range-item">
                    <el-time-select
                      v-model="range.start"
                      :picker-options="startOptions(index)"
                      placeholder="起始时间"
                      :max-time="range.end"
                      @change="handleStartChange(index)"
                    />
                    <span class="separator">-</span>
                    <el-time-select
                      v-model="range.end"
                      :picker-options="endOptions(index)"
                      placeholder="结束时间"
                      :min-time="range.start"
                      @change="handleEndChange(index)"
                    />
                    <el-button
                      v-if="index === timeRanges.length - 1"
                      type="text"
                      icon="el-icon-plus"
                      @click="addRange"
                      :disabled="isLastEndMax"
                    />
                    <el-button
                      v-if="timeRanges.length > 1"
                      type="text"
                      icon="el-icon-minus"
                      @click="removeRange(index)"
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="地域定向:" style="text-align: left;">
                <el-select v-model="beSelectDiYu" placeholder="请选择" @change="diYuHandleSelectionChange" style="text-align: left;">
                  <el-option
                    v-for="(item, index) in mapArray"
                    :key="index"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="性别:" style="text-align: left;">
                <el-radio-group v-model="sex" style="text-align: left;">
                  <el-radio-button label="男"></el-radio-button>
                  <el-radio-button label="女"></el-radio-button>
                  <el-radio-button label="不限"></el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="年龄(不选即不限):" style="text-align: left;" >
                <div>
                  <el-checkbox-group v-model="age" style="text-align: left;">
                    <el-checkbox-button v-for="(item, i) in ages" :label="i" :key="i">
                      {{ item.value }}
                    </el-checkbox-button>
                  </el-checkbox-group>
                </div>
              </el-form-item>
              <el-form-item label="">
                <div id="app">
                  <el-checkbox-group v-model="selectedVersions">
                    <el-checkbox
                      v-for="(version, index) in androidVersions"
                      :key="version.value"
                      :label="version.value"
                    >
                      {{ version.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox-group v-model="selectedPrices">
                  <el-checkbox
                    v-for="(priceRange, index) in priceRanges"
                    :key="priceRange.value"
                    :label="priceRange.value"
                  >
                    {{ priceRange.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
            <el-form label-position="right" :model="formLabelAlign3">
              <el-form-item label="展现形式:" style="text-align: left;">
                <el-cascader
                  style="text-align: left;"
                  v-model="formLabelAlign3.placeType"
                  :options="options4"
                  filterable>
                </el-cascader>
              </el-form-item>
              <el-form-item label="标题打乱(默认打开):" style="text-align: left;">
                <el-switch
                  v-model="daluan"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  style="text-align: left;">
                </el-switch>
              </el-form-item>
              <div v-for="(product, index) in formLabelAlign3.productNames" :key="index" class="product-input">
                <el-form-item :label="'*产品名 ' + (index + 1) + ':'" style="text-align: left;">
                  <el-input
                    v-model="formLabelAlign3.productNames[index]"
                    style="width: 200px;"
                  ></el-input>
                  <el-button @click="addProduct" type="primary" size="small">
                    添加产品名
                  </el-button>
                  <el-button
                    v-if="formLabelAlign3.productNames.length > 1"
                    @click="removeProduct(index)"
                    type="danger"
                    size="mini"
                  >
                    删除
                  </el-button>
                </el-form-item>
              </div>

              <el-form-item :label="'标题：' + formLabelAlign3.title.length + '个'" style="text-align: left;">
                <el-input
                  type="textarea"
                  style="width: 440px;"
                  v-model="titlesString"
                  placeholder="请输入标题（每行一个）"
                  :rows="9"
                  @input="handleInput"
                ></el-input>
                <div
                  v-for="(line, index) in linesWithLimitError"
                  :key="index"
                  style="color: red; font-size: 12px; margin-top: 5px;"
                >
                  第{{ index + 1 }}行超出字符限制（最多 {{ maxLength }} 字）：{{ line }}
                </div>
              </el-form-item>
              <el-form-item label="撞审标题：" style="text-align: left;">
                <el-input
                  type="textarea"
                  style="width: 440px;"
                  v-model="zstitlesString"
                  placeholder="请输入撞审标题（每行一个）"
                  :rows="9"
                  @input="zshandleInput"
                ></el-input>
                <div v-for="(line, index) in zslinesWithLimitError" :key="index" style="color: red; font-size: 12px; margin-top: 5px;">
                  <div></div>侧文案超出字符限制，最多 {{ maxLength }} 个字符：{{ line }}
                </div>
              </el-form-item>
            </el-form>




          </div>
        </el-card>
        <!--图片素材代码-->
        <!--            <el-card class="box-cards" style="height:15%;">-->
        <!--              <div slot="header" class="clearfix">-->
        <!--                <span >批量搭建任务进度</span>-->
        <!--              </div>-->
        <!--              <el-row>-->
        <!--                <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentages"></el-progress>-->
        <!--              </el-row>-->

        <!--            </el-card>-->
        <el-tabs class="box-card" v-model="updateType" >
          <el-tab-pane label="头像" name="first">
            <el-card class="box-card" style="height:90%;overflow: auto;">
              <div slot="header" class="clearfix" style="padding: 18px 20px;">
                <span style="font-weight: 500;">注意辨别是否需要头像</span>
              </div>
              <div style="padding: 0 20px;">
                <el-button
                  type="primary"
                  @click="txonChange"
                  size="small"
                  style="margin-bottom: 15px;"
                >选择头像</el-button>

                <!-- 头像展示区域 -->
                <div style="width: 100%; padding: 20px 0; text-align: center;">
                  <template v-if="txfileList.length > 0">
                    <el-image
                      :src="getImageUrl(txfileList[0])"
                      style="
              height: 300px;
              width: 300px;

              border: 2px solid #FFFFFF;
              box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
              object-fit: cover;
              cursor: pointer;
              transition: all 0.3s ease;
            "
                      @mouseover="e => e.currentTarget.style.transform = 'scale(1.05)'"
                      @mouseout="e => e.currentTarget.style.transform = 'scale(1)'"
                    ></el-image>
                  </template>
                  <div
                    v-else
                    style="
            color: #909399;
            font-size: 14px;
            padding: 20px;
            background: #f5f7fa;
            border-radius: 4px;
          "
                  >暂无头像，请点击上方按钮选择</div>
                </div>
              </div>
            </el-card>
          </el-tab-pane>

          <el-tab-pane label="图片" name="second">
            <el-card class="box-card" style="height:90%;overflow: auto;">
              <div slot="header" class="clearfix">
                <span >素材上传工作区</span>
              </div>
              <el-row>
                <el-upload
                  ref="upload"
                  :multiple="true"
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :file-list="fileList"
                  :on-remove="handleRemove"
                  :http-request="function(){}"
                  :on-preview="handlePictureCardPreview">

                  <!-- 自定义触发按钮 -->
                  <div slot="trigger" class="upload-trigger" @click.stop="onChange">
                    <el-tag>选择图片素材</el-tag>
                  </div>

                  <!-- 自定义文件列表项 -->
                  <template slot="file" slot-scope="{ file }">
                    <div class="file-item">
                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath"
                        alt=""
                      >
                      <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click.stop="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            class="el-upload-list__item-delete"
            @click.stop="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
                    </div>
                  </template>
                </el-upload>

              </el-row>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="视频" name="third">
            <el-card class="box-card" style="height:90%;">
              <div slot="header" class="clearfix">
                <span >视频素材上传工作区</span>
              </div>
              <el-row>
                <!-- 自定义上传按钮 -->

                <div style="display: block">
                  <div>
                    <span>是否自动生成封面</span>
                    <el-switch
                      v-model="videoFMSwitch"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <el-button @click="onChange2">选择视频</el-button>

                </div>

                <!-- 已选列表 -->
                <div class="video-list">
                  <div v-for="item in VideofileList" :key="item.code" class="video-item">
                    <span>{{ item.title }}</span>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      @click="handleRemove2(item.code)"
                    ></el-button>
                  </div>
                </div>
              </el-row>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="撞审图片" name="fourth">
            <el-card class="box-card" style="height:90%;">
              <div slot="header" class="clearfix">
                <span >撞审图片素材上传工作区</span>
              </div>
              <el-row>
                <el-upload
                  ref="upload"
                  :multiple="true"
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :file-list="zsfileList"
                  :on-remove="zshandleRemove"
                  :http-request="function(){}"
                  :on-preview="zshandlePictureCardPreview">

                  <!-- 自定义触发按钮 -->
                  <div slot="trigger" class="upload-trigger" @click.stop="zsonChange">
                    <el-tag>选择图片素材</el-tag>
                  </div>

                  <!-- 自定义文件列表项 -->
                  <template slot="file" slot-scope="{ file }">
                    <div class="file-item">
                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath"
                        alt=""
                      >
                      <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click.stop="zshandlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            class="el-upload-list__item-delete"
            @click.stop="zshandleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
                    </div>
                  </template>
                </el-upload>

              </el-row>
            </el-card>
          </el-tab-pane>

          <el-tab-pane label="撞审视频" name="fifth">
            <el-card class="box-card" style="height:90%;">
              <div slot="header" class="clearfix">
                <span >撞审视频素材</span>
              </div>
              <el-row>
                <!-- 自定义上传按钮 -->
                <dv style="display: block">
                  <div>
                    <span>是否自动生成封面</span>
                    <el-switch
                      v-model="zsvideoFMSwitch"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <el-button @click="zsonChange2">选择撞审视频</el-button>

                </dv>

                <!-- 已选列表 -->
                <div class="video-list">
                  <div v-for="item in zsVideofileList" :key="item.code" class="video-item">
                    <span>{{ item.title }}</span>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      @click="zshandleRemove2(item.code)"
                    ></el-button>
                  </div>
                </div>
              </el-row>
            </el-card>
          </el-tab-pane>
        </el-tabs>

      </el-main>

    </el-container>




  </div>

</template>

<script>
import axios from "axios";
import Decimal from "decimal.js";
import Vue2 from './sucaiku.vue';
import { bus } from '../../bus.js';

export default {
  components: { Vue2 },
  data() {
    const cityOptions = [];
    const c1=[
      {
        id:25,
        value:'0-17岁'
      },
      {
        id:26,
        value:'18-24岁'
      },
      {
        id:27,
        value:'25-29岁'
      },
      {
        id:28,
        value:'30-39岁'
      },
      {
        id:29,
        value:'40-49岁'
      },
      {
        id:30,
        value: '50岁及以上'
      },
    ]
    return {
      videoFMSwitch:false,
      zsvideoFMSwitch:false,
      zsspchange:false,
      spchange:false,
      zstpchange:false,
      tpchange:false,
      txchange:false,
      currentNormalIndex: 0,
      currentReviewIndex: 0,
      txfileList:[],
      txfileCode:[],
      countdialogVisible: false,
      countformData: {
        normalCount: 0,
        reviewCount: 0
      },
      zsfileList:[],
      isoldgroupprice:false,
      oldGroupPrice:'',
      newplanflag:false,
      ePlanId:'',
      linesWithLimitError: [], // 存储超出字符限制的行
      zslinesWithLimitError: [], // 存储超出字符限制的行
      maxLength: 26, // 默认最大字符数
      timeRanges: [{ start: '00:00', end: '24:00' }],
      isguanz:false,
      stopAll:false,
      titlesString:'',
      zstitlesString:'',
      zstitleList:[],

      categoryName:'',
      beSelectCategory:null,
      categoryList:[],

      // 可选的分类数据
      categories: [
        { categoryName: '星光剧场-男频', categoryId: 2917, categoryUid: 'b79d4d58dc196dd941f8', categoryUtoken: '43f9d1624140e71944945eb06d77dbb5739fe597148faae039887aaa9fbf0f59' },
        { categoryName: '星光剧场-女频', categoryId: 3148, categoryUid: 'b79d4d58dc196dd941f8', categoryUtoken: 'd7408c1fda253deabbc079a42e7e3e4590213f1a4d2cac7e786c5761ff84ab2d' },
        { categoryName: '小说阅读', categoryId: 2725, categoryUid: '3a05d5cac153d5b5b571', categoryUtoken: '6a5de1e302a7d78703b33d406aae6216f28d05059f026e6c0b70daf3b916bffc' },
        { categoryName: '梦享剧场', categoryId: 2700, categoryUid: '1ed11a001527004c7013', categoryUtoken: 'aa5e70199f4bfb02ff782f76564ba2d1e86623f63b3133cb56fcfb0d11fa93a9' },
        { categoryName: '小说大全', categoryId: 2910, categoryUid: 'b14dde881a82e006f4d3', categoryUtoken: '6a5de1e302a7d78703b33d406aae6216f28d05059f026e6c0b70daf3b916bffc' },
        { categoryName: '繁花剧场', categoryId: 3082, categoryUid: '68fb22cb1d92c8ac37b0', categoryUtoken: 'd7408c1fda253deabbc079a42e7e3e4590213f1a4d2cac7e786c5761ff84ab2d' },
      ],

      sucaikus: [
        { uname: 'psl', uid: 'f6f0b505a7368e5ea402', utoken: '0a306397d2767ea3bf2465471bac8d15efa05f557df5d9b3142da65f73eb19d5' },
        { uname: 'lsp', uid: 'fa271d870eb23e2483fd', utoken: '0a306397d2767ea3bf2465471bac8d15efa05f557df5d9b3142da65f73eb19d5' },
        { uname: '桂小伟', uid: 'c786bae366b78fff1b30', utoken: '47a66fdfd401dfc6878ca5de83e95c52b564c0bd403976568a6d6f742af69bc0' },
        { uname: '富康', uid: 'eba3ec4451aecf7a1f41', utoken: '47a66fdfd401dfc6878ca5de83e95c52b564c0bd403976568a6d6f742af69bc0' },
        { uname: '杨康', uid: 'b62a84b350478d655647', utoken: 'c2cd372657636dab9d4e634188d88465c70da26370280712a4e4604cfa2f00b1' },
        { uname: '葛磊', uid: 'c35f8f61b4136b3ded15', utoken: 'c14066d0edba0f71984805a3ac5ad8146f64fdca09448e5092b4df732922f8b0' },
        { uname: '唐莹', uid: 'b510d1bf06f83682c908', utoken: '4fa940040985146f070b1eb8f19cc3084570842faca8bf7317e470e0d5d97149' },
        { uname: '小晴', uid: '27db5919944236f15760', utoken: '1fa0c26330fff171935f23536cffb7435c297b123fb2a1fea22f8164b42864ff' },
        { uname: '郑佳宇', uid: 'dc6b8813bff8b4d0b881', utoken: 'a0c1a838343d5afa4a229db37d552aea171d8407af32cf0da0f006da172c0da0' },
        { uname: '林俊杰', uid: '6de39b814c9622959709', utoken: 'fc6bc6e5fc86e17adb07b94067f8a1ec2622ec606573711e8fc75a7755d0ff3d' },
        { uname: 'hxz', uid: '03f4d7ac3f91f8369b99', utoken: 'fe347189c3b4f87faee5a2073edf22e8b0e794e495977bd736f649a4d6d9b867' },
        { uname: 'hxz2', uid: '58e9c2a1745994f07826', utoken: '486f4b28e581115a8553250038402b292903557a244437c935469cfb3b801c85' },
        { uname: '汪洋', uid: 'bd7d22c54904e1ae5e4c', utoken: '13c5639d4c2ac677ad09deee0e0ef4abd4f540a7eedf374b4ea328a655e6ff44' },
        { uname: '张栖宇', uid: '70615012fb3f73e8ba49', utoken: 'a4bc5a9f3ea89a29682ea6f4f7fbe1fc280e28a941312bce21dfdf423f700ccc' },
        { uname: 'cxy', uid: '826ac4833e1b376666d1', utoken: 'd0d4a903a8b88679f0b8bd9ee01dcd51dbd8383accbc1ae7d179bec1c01fdd58' },
        { uname: '陈慧', uid: 'a28c5beba2b6c64119e3', utoken: '71c85b5fac0942397e50ee71e0b7f727df69c173fab181b2b160dd477c2a822a' },
        { uname: '吴周莉', uid: 'd2cc94284ddfac2df59b', utoken: 'd822ad1012a19acfaf257523c9039d1776947197404881abf4a3578b66781dc7' },
        { uname: '周尚安', uid: '7cb1b105d2b29238f724 ', utoken: 'd822ad1012a19acfaf257523c9039d1776947197404881abf4a3578b66781dc7' },


      ],
      zjcookie:'',
      sucainame:'', // 存储选中的素材名称
      selectedsucaiku: null ,// 存储选中的完整对象
      selectedCategoryName: '', // 存储选中的分类名称
      selectedCategory: null ,// 存储选中的完整对象
      priceRanges: [
        { label: '>4500', value: 1530022 },
        { label: '4000~4500', value: 1530021 },
        { label: '3500~4000', value: 1530020 },
        { label: '3000~3500', value: 1530019 },
        { label: '2500~3000', value: 1530018 },
        { label: '2000~2500', value: 1530017 },
        { label: '1500~2000', value: 1530016 },
        { label: '1000~1500', value: 1530015 },
        { label: '0~1000', value: 1530014 }
      ],
      // 默认勾选所有购机价格区间ID
      selectedPrices: [
        1530014,1530022, 1530021, 1530020, 1530019,
        1530018, 1530017, 1530016, 1530015
      ],
      // 定义安卓版本和对应的值
      androidVersions: [
        { label: '安卓4及以下', value: 1650003},
        { label: '安卓5', value: 1650004 },
        { label: '安卓6', value: 1650005 },
        { label: '安卓7', value: 1650006 },
        { label: '安卓8', value: 1650007 },
        { label: '安卓9', value: 1650008 },
        { label: '安卓10', value: 1650001 },
        { label: '安卓11', value: 1650002 },
        { label: '安卓12', value: 1650009 },
        { label: '安卓13', value: 1650010 },
        { label: '安卓14', value: 1650011 }
      ],
      // 默认勾选所有的安卓版本值
      selectedVersions: [1650001, 1650002, 1650003, 1650004, 1650005, 1650006, 1650007, 1650008, 1650009, 1650010,1650011],

      androidVersionSetList:[],
      phonePriceSetList:[],
      beSelectAdType: '', // 被选中的广告类型
      adTypeList: [
        { label: '网址', value: 1 },
        { label: '快应用', value: 8 }
      ],
      myAdType:'',
      customList2:'',
      customListpc:'',
      customListrqb:[],
      customListrqbpc:[],
      erjihangye:[],
      options5:[
        {
          value: '2100018',
          label: '电商',
          children: [{
            value: '2220145',
            label: '优惠券'
          },
            {
              value: '2220142',
              label: '综合电商平台'
            },

          ]},



        {
          value: '2100024',
          label: '系统/工具',
          children: [
            {
              value: '2220196',
              label: '体育健康'
            }, {
              value: '2220202',
              label: '日常工具'
            }, {
              value: '2220200',
              label: '天气日历'
            },{
              value: '2220195',
              label: '系统软件  '
            },



          ]},


        {
          value: '2100009',
          label: '出版经营',
          children: [{
            value: '2220037',
            label: '出版物'
          }]},
        {
          value: '2100019',
          label: '直营电商',
          children: [
            {
              value: '2220149',
              label: '日用百货'
            },
            {
              value: '2220154',
              label: '其他'
            },
            {
              value: '2220159',
              label: '医药保健'
            },
            {
              value: '2220157',
              label: '零食饮料'
            },
          ]
        },

        {
          value: '2100013',
          label: '生活服务',
          children: [{
            value: '2220099',
            label: '综合生活服务'
          },]},
        {
          value: '2100023',
          label: '娱乐影视',
          children: [{
            value: '2220193',
            label: '小说平台'
          },{
            value: '2220187',
            label: '视频'
          }, {
            value: '2220192',
            label: '段子漫画'
          }, ]},
        {
          value: '2100012',
          label: '医疗服务',
          children: [
            {
              value: '2220064',
              label: '医疗器械'
            },
            {
              value: '2220072',
              label: '保健用品'
            },
            {
              value: '2220063',
              label: '医疗科室'
            },
            {
              value: '2220070',
              label: '药品'
            }



          ]},

        {
          value: '2100020',
          label: '教育',
          children: [{
            value: '2220162',
            label: '素质教育'
          },{
            value: '2220161',
            label: '理财培训'
          },
            {
              value: '2220167',
              label: '职业培训'
            },


          ]},
        {
          value: '2100011',
          label: '食品',
          children: [{
            value: '2220046',
            label: '散装食品'
          },

            {
              value: '2220062',
              label: '保健食品'
            },]},
        {
          value: '2100029',
          label: '金融',
          children: [{
            value: '2220260',
            label: '保险'
          },  ]
        },
        // {
        //   value: 2220187,
        //   label: '视频',
        // },{
        //   value: 2220193,
        //   label: '小说平台',
        // },
      ],
      sex:'不限',
      customList:[1247469,1247470,1223942],
      age:[],
      sexList:[],

      zzIdList:[],
      ageIdList:[],
      ages : c1,
      regionCodeList:[
        '110000',
        '120000',
        '130000',
        '140000',
        '150000',
        '210000',
        '220000',
        '230000',
        '310000',
        '320000',
        '330000',
        '340000',
        '350000',
        '360000',
        '370000',
        '410000',
        '420000',
        '510000',
        '430000',
        '440000',
        '450000',
        '460000',
        '500000',
        '520000',
        '530000',
        '540000',
        '610000',
        '620000',
        '630000',
        '640000',
        '650000',
      ],
      flag:false,
      updateType:'',
      listname:[],
      time_list:'',
      timeList:[
        {
          value:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          label:'全天投放'
        },
        {
          value:'000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111',
          label:'五点'
        },
        {
          value:'000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111',
          label:'六点'
        },
        {
          value:'000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111',
          label:'七点'
        },
        {
          value:'000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111',
          label:'八点半'
        },
        {
          value:'000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111',
          label:'九点后'
        },
        {
          value:'000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111',
          label:'九点半'
        },
        {
          value:'000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111',
          label:'十点'
        },
        {
          value:'000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111',
          label:'十点半'
        },
        {
          value:'000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111',
          label:'十一点'
        },{
          value:'000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111',
          label:'十四点'
        },
        {
          value:'000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111',
          label:'十六点'
        },
        {
          value:'000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111',
          label:'十七点'
        },
        {
          value:'000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111',
          label:'十八点'
        }],
      names:'',
      idsname:[],

      option1: [{
        value: '1',
        label: '非应用商店'
      },
        {
          value: '2',
          label: '广告联盟'
        }],

      options3: [
        {
          value: '4',
          label: '表单提交'
        },
        {
          value: '5',
          label: '自定义激活'
        }, {
          value: '7',
          label: '添加到桌面'
        },{
          value: '12',
          label: '自定义付费'
        },
        {
          value: '13',
          label: '自定义拉活'
        },
        {
          value: '52',
          label: '快应用/快游戏ROI1-广告变现'
        }],
      flag1:true,
      flag2:true,
      options4: [
        {
          value: '1',
          label: '信息流',
          children: [       {
            value: '62',
            label: '横板大图',
          },
            {
              value: '63',
              label: '竖版大图',
            },
            {
              value: '4',
              label: '组图',
            },
            {
              value: '3',
              label: '小图',
            },{
              value: '61',
              label: '横板视频'
            },{
              value: '75',
              label: '竖版视频'
            }]
        },

        {
          value: '2',
          label: '开屏',
          children: [
            {
              value: '35',
              label: '竖版大图',
            },
            {
              value: '85',
              label: '横版大图',
            },


          ]
        },
        //   {
        //   value: '2',
        //   label: '开屏'
        // },{
        //   value: '3',
        //   label: 'banner'
        // },
        {
          value: '5',
          label: '原生广告',
          children: [{
            value: '48',
            label: '横板大图',
          },
            {
              value: '209',
              label: '竖版大图',
            },
            {
              value: '4',
              label: '组图',
            },
            {
              value: '121',
              label: '小图',
            }
            ,  {
              value: '242',
              label: '竖版视频',
            },
            {
              value: '122',
              label: '横版视频',
            },

          ]
        },
        {
          value: '4',
          label: '插屏',
          children: [
            {
              value: '39',
              label: '竖版大图(780*800)',
            },
            // {
            //   "displayName": "竖版大图",
            //   "dtoList": [
            //     {
            //       "displayType": 4,
            //       "titleLength": 0,
            //       "fileSize": 50,
            //       "id": 39,
            //       "fileType": "1,2",
            //       "displayMode": 4,
            //       "dimensions": "780*800"
            //     },
            //     {
            //       "displayType": 4,
            //       "titleLength": 26,
            //       "fileSize": 300,
            //       "id": 207,
            //       "fileType": "1,2",
            //       "displayMode": 1,
            //       "dimensions": "1080*1920"
            //     }
            //   ],
            //   "displayMode": 10001
            // },
            // {
            //   "displayName": "横版大图",
            //   "dtoList": [
            //     {
            //       "displayType": 4,
            //       "titleLength": 26,
            //       "fileSize": 300,
            //       "id": 208,
            //       "fileType": "1,2",
            //       "displayMode": 1,
            //       "dimensions": "1280*720"
            //     }
            //   ],
            //   "displayMode": 10000
            // },
            // {
            //   "displayName": "竖版视频",
            //   "dtoList": [
            //     {
            //       "displayType": 4,
            //       "titleLength": 8,
            //       "fileSize": 51200,
            //       "id": 145,
            //       "fileType": "1,2,6",
            //       "displayMode": 10,
            //       "dimensions": "720*1280"
            //     }
            //   ],
            //   "displayMode": 10010
            // },
            // {
            //   "displayName": "横版视频",
            //   "dtoList": [
            //     {
            //       "displayType": 4,
            //       "titleLength": 8,
            //       "fileSize": 51200,
            //       "id": 142,
            //       "fileType": "1,2,6",
            //       "displayMode": 5,
            //       "dimensions": "1280*720"
            //     }
            //   ],
            //   "displayMode": 10005
            // }

          ]
        }
      ],
      accounts:'',

      daluan:true,
      value: '',
      formLabelAlign: {
        name: '',
        mediaType: '',
        dailyBudget:''
      },
      formLabelAlign1: {
        name: '',
        cvType: '',
        ocpxPrice: ''
      },
      normId:[61,4,3],
      formLabelAlign3: {
        placeType: '',
        title: [],
        productNames:[''],
      },
      percentage:0,
      percentages:0,
      fileList: [],
      VideofileList: [],
      zsVideofileList: [],

      creativeList:[],
      arr:{},
      idsList:[
        {
          id:'',
          username:'',
          ids:'',
          twoname:'',
          url:'',
          xiaoshuourl:'',
          baoguangurl:'',
          token:'',
          idsname:'',
          planId:'',
          groundId:'',
          planName:''
        }
      ],
      dialogImageUrl: '',
      zsdialogImageUrl: '',
      dialogVisible: false,
      zsdialogVisible: false,
      fileCode:[],
      zsfileCode:[],
      zsvideofileCode:[],
      videofileCode:[],
      two:[{
        id:'',
        twoname:'',
      }],
      // towToken:[],
      towName:'',
      username:'',
      advertiseQualificationId:'', // 资质id
      beSelectDiYu: '',
      beSelectMap:{},
      // 存储定向的
      mapArray: [
        {
          name: "不限",
          map: {
            region: {
              regionCodeList:  [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                810000,
                820000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "福建帝江",
          map: {
            region: {
              regionCodeList:  [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "满芳小说  ",
          map: {
            region: {
              regionCodeList:   [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "麒麟养生书",
          map: {
            region: {
              regionCodeList:  [
                110000,
                120000,
                130000,
                140000,
                210100,
                210200,
                220200,
                230100,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                610000,
                640000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "爱读小说",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "码力连",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "帝江瑟瑟",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "爱测评投放地区xq",
          map: {
            region: {

              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "艾草枕批搭",
          map: {
            region: {

              regionCodeList: [
                110000,
                120000,
                130100,
                130200,
                130300,
                130800,
                130900,
                131000,
                131100,
                140100,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140900,
                141000,
                141100,
                150100,
                150200,
                150300,
                150600,
                150700,
                150800,
                150900,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340100,
                340200,
                340300,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341700,
                341800,
                350000,
                360100,
                360200,
                360300,
                360400,
                360500,
                360600,
                360800,
                360900,
                361000,
                370100,
                370200,
                370300,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371400,
                371600,
                410100,
                410300,
                410600,
                411000,
                411100,
                411200,
                419098,
                420100,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450100,
                450200,
                450300,
                450400,
                450500,
                450600,
                450700,
                451400,
                460000,
                510100,
                510300,
                510400,
                510600,
                510700,
                510900,
                511100,
                511400,
                511500,
                511600,
                511800,
                520100,
                520300,
                530100,
                530300,
                530400,
                530500,
                530700,
                530900,
                610100,
                610200,
                610300,
                610400,
                610500,
                610600,
                610800,
                620100,
                620299,
                620300,
                620900,
                630100,
                640100,
                640200,
                640300,
                650100
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "魔豆",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "悠漫步",
          map: {
            region: {
              regionCodeList:   [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "追书",
          map: {
            region: {
              regionCodeList:  [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320300,
                320400,
                320600,
                320700,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                440200,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520100,
                520200,
                520300,
                520400,
                520500,
                522300,
                522600,
                522700,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "福建追书",
          map: {
            region: {

              regionCodeList:[
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320300,
                320400,
                320600,
                320700,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                440200,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520100,
                520200,
                520300,
                520400,
                520500,
                522300,
                522600,
                522700,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              , // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "诸云",
          map: {
            region: {
              regionCodeList: [
                130100,
                130200,
                130300,
                130400,
                130500,
                130600,
                130700,
                130800,
                130900,
                131100,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340100,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "繁花剧场",
          map: {
            region: {
              regionCodeList:  [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "肥猫小说",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "生米",
          map: {
            region: {
              regionCodeList: [

                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,

                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                // 420000,
                420200,420300,420500,420600,420700,420800,420900,421000,421100,421200,421300,422800,429078,429093,429094,429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "火苗",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360100,
                360200,
                360300,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370100,
                370200,
                370400,
                370500,
                370600,
                370700,
                370800,
                371000,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "四组城市屏蔽",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "趣点",
          map: {
            region: {
              regionCodeList:  [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                441999,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "春河小说",
          map: {
            region: {
              regionCodeList:  [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320400,
                320500,
                320600,
                320700,
                320800,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                350200,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360200,
                360300,
                360400,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370200,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371400,
                371500,
                371600,
                410200,
                410300,
                410400,
                410500,
                410600,
                410800,
                410900,
                411000,
                411100,
                411200,
                411300,
                411400,
                411500,
                411600,
                411700,
                419098,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530300,
                530400,
                530500,
                530600,
                530700,
                530800,
                530900,
                532300,
                532500,
                532600,
                532800,
                532900,
                533100,
                533300,
                533400,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "呱呱",
          map: {
            region: {
              regionCodeList:   [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },


        {
          name: "飞鱼",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "惟阅免费小说",
          map: {
            region: {
              regionCodeList:  [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },

          }
        },
        {
          name: "psl生米",
          map: {
            region: {
              regionCodeList:   [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型

            },
          }
        },
      ],

      showVue2: false,  // 控制 Vue2 显示/隐藏
      receivedData: null // 存储从 Vue2 返回的数据
    };
  },
  watch: {  // 新增监听器
    result(newVal) {
      this.time_list = newVal
    }
  },
  computed: {
    result() {
      const bits = new Array(48).fill(0)
      this.timeRanges.forEach(range => {
        const start = this.timeToIndex(range.start)
        const end = this.timeToIndex(range.end)
        for (let i = start; i < end && i < 48; i++) {
          bits[i] = 1
        }
      })
      const resultStr = bits.join('');
      this.time_list =  resultStr.repeat(7);
      console.log( this.time_list)
    },

    isLastEndMax() {
      const last = this.timeRanges[this.timeRanges.length - 1]
      return this.timeToIndex(last.end) >= 47
    }
  },

  mounted() {
    // 监听事件总线的数据传递事件


    bus.$on('data-selected', (data) => {

      this.receivedData = data;
      this.selectedsucaiku = data.sucaiku
      if (this.txchange) {
        if (data.img.length > 0) {
          this.txfileList = data.img
          this.txfileCode[0] = data.img[0].code
        } else {
          this.$message.warning('请选择头像');
        }
        this.txchange = false
      } else if (this.tpchange) {
        if (data.img.length > 0) {
          this.fileList = data.img
          this.fileCode = data.img.map(item => item.code);
        }else {
          this.$message.warning('请至少选择一个图片素材');
        }
        this.tpchange = false
      }
      else if (this.zstpchange) {
        if (data.img.length > 0) {
          this.zsfileList = data.img
          this.zsfileCode = data.img.map(item => item.code);
        }else {
          this.$message.warning('请至少选择一个图片素材');
        }
        this.zstpchange = false
      }
      else if (this.spchange) {
        if (data.video.length > 0) {
          this.VideofileList = data.video
          // this.videofileCode = data.video.map(item => item.code);
        }else {
          this.$message.warning('请至少选择一个视频素材');
        }
        this.spchange = false
      }
      else if (this.zsspchange) {
        if (data.video.length > 0) {
          this.zsVideofileList = data.video
          this.zsvideofileCode = data.video.map(item => item.code);
        }else {
          this.$message.warning('请至少选择一个视频素材');
        }
        this.zsspchange = false
      }
      this.showVue2 = false; // 关闭 Vue2
    });
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    bus.$off('data-selected');
  },
  methods: {

    getImageUrl: function(item) {
      var base = 'https://ads-marketing-vivofs.vivo.com.cn/'
      return base + (item.filePath || '').replace(/^\//, '')
    },
    handleInput() {
      // 根据 mediaType 判断每行最大字符数
      this.maxLength = this.formLabelAlign.mediaType === '1' ? 26 : 15;

      // 将文本域的内容按行分割并过滤掉空行
      this.formLabelAlign3.title = this.titlesString.split('\n').filter(line => line.trim());

      // 检查每一行是否超过字符限制，并保存超出限制的行
      this.linesWithLimitError =  this.formLabelAlign3.title
        .map((line, index) => ({
          line: line,
          index: index + 1,
          length: line.length,
        }))
        .filter(item => item.length > this.maxLength) // 过滤掉没有超出限制的行
        .map(item => item.line); // 仅返回超出限制的行文本


      // 如果存在超出字符数的行，更新提示信息
    },
    zshandleInput() {
      // 根据 mediaType 判断每行最大字符数
      this.maxLength = this.formLabelAlign.mediaType === '1' ? 26 : 15;

      // 将文本域的内容按行分割并过滤掉空行
      this.zstitleList = this.zstitlesString.split('\n').filter(line => line.trim());

      // 检查每一行是否超过字符限制，并保存超出限制的行
      this.zslinesWithLimitError =  this.zstitleList
        .map((line, index) => ({
          line: line,
          index: index + 1,
          length: line.length,
        }))
        .filter(item => item.length > this.maxLength) // 过滤掉没有超出限制的行
        .map(item => item.line); // 仅返回超出限制的行文本


      // 如果存在超出字符数的行，更新提示信息
    },
    timeToIndex(time) {
      if (time === '24:00') return 48
      const [h, m] = time.split(':').map(Number)
      return h * 2 + (m === 30 ? 1 : 0)
    },

    indexToTime(index) {
      if (index === 48) return '24:00'
      const hours = Math.floor(index / 2)
      const mins = index % 2 === 0 ? '00' : '30'
      return `${String(hours).padStart(2, '0')}:${mins}`
    },

    startOptions(index) {
      const minTime = index === 0
        ? '00:00'
        : this.timeRanges[index - 1].end
      const maxTime = index < this.timeRanges.length - 1
        ? this.timeRanges[index + 1].start
        : '24:00'

      const times = []
      let startIndex = this.timeToIndex(minTime)
      const endIndex = this.timeToIndex(maxTime)

      while (startIndex <= endIndex) {
        times.push(this.indexToTime(startIndex))
        startIndex++
      }

      return {
        start: '00:00',
        end: '24:00',
        step: '00:30',
        selectableRange: times.join(' - ')
      }
    },

    endOptions(index) {
      const startIndex = this.timeToIndex(this.timeRanges[index].start)
      const times = []

      for (let i = startIndex; i <= 48; i++) {
        times.push(this.indexToTime(i))
      }

      return {
        start: '00:00',
        end: '24:00',
        step: '00:30',
        selectableRange: times.join(' - ')
      }
    },

    addRange() {
      const last = this.timeRanges[this.timeRanges.length - 1]
      this.timeRanges.push({
        start: last.end,
        end: '24:00'
      })
    },

    removeRange(index) {
      if (this.timeRanges.length <= 1) return
      this.timeRanges.splice(index, 1)
    },

    handleStartChange(index) {
      const current = this.timeRanges[index]
      // 确保结束时间 >= 开始时间
      if (this.timeToIndex(current.start) > this.timeToIndex(current.end)) {
        this.$set(current, 'end', current.start)
      }
      // 更新后续时间段的开始时间
      if (index < this.timeRanges.length - 1) {
        const next = this.timeRanges[index + 1]
        this.$set(next, 'start', current.end)
        // 检查后续时间段是否有效
        if (this.timeToIndex(next.end) < this.timeToIndex(next.start)) {
          this.$set(next, 'end', next.start)
          this.handleEndChange(index + 1)
        }
      }
    },

    handleEndChange(index) {
      const current = this.timeRanges[index]
      // 更新后续时间段的开始时间
      if (index < this.timeRanges.length - 1) {
        const next = this.timeRanges[index + 1]
        this.$set(next, 'start', current.end)
        // 检查后续时间段是否有效
        if (this.timeToIndex(next.end) < this.timeToIndex(next.start)) {
          this.$set(next, 'end', next.start)
          this.handleEndChange(index + 1)
        }
      }
      // 确保开始时间 <= 结束时间
      if (this.timeToIndex(current.start) > this.timeToIndex(current.end)) {
        this.$set(current, 'start', current.end)
      }
    },
    async  fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    sckhb() {
      const params = new URLSearchParams();
      let idsString = this.idsList.map(item => item.ids).join(',');
      console.log(this.selectedsucaiku)
      let cookieid =this.zjcookie+';b_marketing_subid='
        +this.selectedsucaiku.scId

      params.append('targetUserIds', idsString);
      params.append('cookie', cookieid)
      // 使用 axios 发送 GET 请求，将参数以查询字符串的形式附加到 URL 上
      axios.get('https://control.zjwec.cn/api/kaihu/sendShareRequest', {
        params: params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(res => {
          console.log(res.data); // 处理返回的数据
        })
        .catch(error => {
          console.error('Error:', error); // 处理错误
        });
    },

    clearShangPing(){
      this.categoryName =''
      this.beSelectCategory=null
      this.categoryList=[]

    },
    async GetPlanId(id,token){
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      await axios.post(`api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
        {
          "lastId":0,
          "deleted": 0,
          "pageSize": 100
        }
      ).then(
        res=>{
          this.ePlanId = (res.data && res.data.data && res.data.data.lastId) ? res.data.data.lastId : '';
        }
      )
    },

    async GetGroupPrice(id, token) {
      let allData = []; // 存储所有 data 数据
      let currentLastId = 0; // 初始 lastId
      let lastValidLastId = null; // 记录最后一次有效的 lastId

      while (currentLastId !== undefined && currentLastId !== null) {
        const timestamp = Date.now().toString();
        const nonce = Math.floor(Math.random() * 100000000000);

        try {
          const response = await axios.post(
            `api/openapi/v1/ad/group/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
            {
              lastId: currentLastId,
              deleted: 0,
              pageSize: 100
            }
          );

          const responseData = response.data && response.data.data; // 兼容 ES5 的写法
          if (responseData) {
            // 拼接数据
            if (Array.isArray(responseData.data)) {
              allData = allData.concat(responseData.data);
            }

            // 更新 lastId
            if (responseData.lastId !== undefined && responseData.lastId !== null) {
              lastValidLastId = responseData.lastId;
              currentLastId = responseData.lastId;
            } else {
              currentLastId = null; // 终止循环
            }
          } else {
            currentLastId = null; // 数据异常终止
          }
        } catch (error) {
          console.error("请求失败:", error);
          break;
        }
      }

      console.log("最后获取到的 lastId:", lastValidLastId);

      // 查找目标对象
      const targetObject = allData.find(item => item.id === lastValidLastId);
      console.log("匹配对象:", targetObject);

// 安全处理 undefined 和属性访问
      if (targetObject && typeof targetObject.ocpxPrice !== 'undefined') {
        this.oldGroupPrice = targetObject.ocpxPrice;
      } else {
        // 备选方案：可以设置默认值/保持原值/抛出警告
        console.warn('未找到匹配对象或 ocpxPrice 不存在');
        this.oldGroupPrice = new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(); // 或保留原值：delete this.oldGroupPrice;
      }

    },

    handleCategoryChange() {
      // 根据选中的分类名称查找完整的对象
      this.selectedCategory = this.categories.find(category => category.categoryName === this.selectedCategoryName);
    },
    // handlesucaiku() {
    //   // 根据选中的分类名称查找完整的对象
    //   this.selectedsucaiku = this.sucaikus.find(sucaiku => sucaiku.uname === this.sucainame);
    //
    // },
    handleQuery() {
      if (this.selectedCategoryName) {
        // 发起请求，传入选中的分类名称
        this.queryCategoryData();
      } else {
        this.$message.warning('请选择一个分类');
      }
    },
    // 监听选择框值变化的方法
    CategorySelectHandle(value) {
      console.log('选中的商品对象:', value);
      // 在此执行任何额外的操作，比如发送请求、处理逻辑等
      // this.$message.info(`你选择了: ${newValue.name}`);
      this.beSelectCategory = this.categoryList.find(item => item.id === value);
      console.log('选中的商品对象是'+  JSON.stringify(this.beSelectCategory)  )
    },
    queryCategoryData() {
      // 发送请求，传入商品库ID
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      console.log(this.selectedCategory)
      this.$axios.post(`api/openapi/v1/ad/product/info/page?access_token=${this.selectedCategory.categoryUtoken}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${this.selectedCategory.categoryUid}`, {
        productLibraryId:this.selectedCategory.categoryId,
        pageSize:1000
      })
        .then(response => {
          this.categoryList = response.data.data.list

          console.log('查询结果:', response.data.data.list);
          // 这里可以处理请求成功后的逻辑
          this.$message.success('查询成功');
        })
        .catch(error => {
          console.error('请求失败:', error);
          this.$message.error('查询失败');
        });
    },
    // 添加新的输入框
    addProduct() {
      this.formLabelAlign3.productNames.push('');
    },
    // 删除指定索引的输入框
    removeProduct(index) {
      if (this.formLabelAlign3.productNames.length > 1) {
        this.formLabelAlign3.productNames.splice(index, 1);
      }
    },
    diYuHandleSelectionChange(){
      this.beSelectMap = this.mapArray.find(item => item.name === this.beSelectDiYu);

      console.log("选中的定向是："+JSON.stringify(this.beSelectMap))
    },
    shuffle(arr){
      var l = arr.length
      var index, temp
      while(l>0){
        index = Math.floor(Math.random()*l)
        temp = arr[l-1]
        arr[l-1] = arr[index]
        arr[index] = temp
        l--
      }
      return arr
    },

    // 获取资质id
    // 发送请求获取数据
    async GetZZData(uid,token) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      const url = `api/openapi/v1/advertise/qualification/list?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`;
      const response = await axios.post(url, {});

      if (response.data.code === 0 && response.data.data) {

        console.log("账户"+ uid+ "取到的所有行业是"+response.data.data)
        this.zzIdList  = response.data.data
      }
      return [];
    },
    clearfile(){

      this.fileList = []
      this.VideofileList=[]
    },
    zsclearfile(){

      this.zsfileList = []
      this.zsVideofileList=[]
    },
    async getVideoFM() {
      // 公共请求函数封装
      const fetchCodes = async (switchFlag, fileList, cookieName, codeField) => {
        if (!switchFlag) return false;
        if (fileList.length === 0) {
          this.$message.info(`请选择${cookieName}素材`);
          return false;
        }

        const cookie = this.zjcookie + ";b_marketing_subid=" + this.selectedsucaiku.scId;
        const codes = fileList.map(file => file.code);

        try {
          const requests = codes.map(videoCode =>
            axios.get(`https://control.zjwec.cn/api/vivo/frameSave`, {
              params: { videoCode, cookie }
            }).catch(error => { // 捕获单个请求错误
              console.error('单个请求失败:', error);
              return null; // 标记失败请求
            })
          );

          const results = await Promise.all(requests);
          const validResults = results.filter(res => res !== null); // 过滤失败请求

          if (validResults.length !== results.length) {
            this.$message.warning("部分请求失败，请检查控制台");
          }

          const sortedCodes = results.map(result =>
            result ? result.data.data.code : null // 保持原始顺序，失败项为null
          );

          this[codeField] = sortedCodes;
          console.log('按顺序排列的 code 数组：', sortedCodes);
        } catch (error) {
          console.error('全局请求错误：', error);
          this.$message.error("请求发生错误");
        }
      };

      // 处理普通视频
      await fetchCodes(
        this.videoFMSwitch,
        this.VideofileList,
        "普通视频",
        "fileCode"
      );

      // 处理撞审视频
      await fetchCodes(
        this.zsvideoFMSwitch,
        this.zsVideofileList,
        "撞审视频",
        "zsfileCode"
      );
    },
    async GetPlan(){
      this.countdialogVisible = false
      this.sckhb()

      // 判断是否自动取封面
      await  this.getVideoFM()


      if (!this.customListpc) {
        this.flag2 = false;
      } else {
        this.customListrqbpc = this.customListpc
          .split(',')
          .map(t => parseInt(t, 10));
        console.log(this.customListrqbpc);
        this.flag2 = true;
      }

      if (this.customList2===''){
        this.flag1=false
      }else {
        this.customListrqb=[]
        let temp=[]
        temp=this.customList2.split(",");
        for (let t1 in temp){
          this.customListrqb[t1]=parseInt(temp[t1])
        }
        console.log(this.customListrqb)
        this.flag1=true
      }
      this.sexList=[];
      if (this.sex==="女"){
        this.sexList[0]=20
      }else if (this.sex==="男"){
        this.sexList[0]=19
      }
      this.ageIdList=[]
      for (let key in this.age){
        this.ageIdList[key]=this.ages[this.age[key]].id
      }
      console.log(this.ageIdList)
      if (this.formLabelAlign3.placeType[1]==='61' ||this.formLabelAlign3.placeType[1]==='122'){
        let t=0;
        for (let key in this.idsList){
          if (this.daluan===true){
            this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
          }
          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            dailyBudget:this.formLabelAlign.dailyBudget,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          let parms1={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          await this.GetZZData(this.idsList[key].ids,this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids,this.idsList[key].token)
          await this.GetGroupPrice(this.idsList[key].ids,this.idsList[key].token)
          if(this.ePlanId !==''  && this.newplanflag == true){
            let groundData={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              campaignId:this.ePlanId,
              webSiteUrl:this.idsList[key].url,
              id:key,
              startDate:this.startDate,
              ocpxPrice:this.isoldgroupprice?this.oldGroupPrice:new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name:this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)
          }
          else {
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)

          }
          let data = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            groupId: this.idsList[key].groundId,
          }
          await this.PostGroupTime(data)
          // 获取素材配置参数
          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // 生成普通素材队列（图片+视频+标题）
          const normalMaterials = Array.from({length: normalCount}, (_, i) => {
            const pos = (this.currentNormalIndex + i) % this.fileCode.length;
            return {
              img: this.fileCode[pos],
              // video: this.videofileCode[pos],
              video: this.VideofileList[pos].code,
              title: this.formLabelAlign3.title[pos],
              type: 'normal'
            };
          });

          console.log(this.zsVideofileList)
          // 生成撞审素材队列（图片+视频+标题）
          const reviewMaterials = Array.from({length: reviewCount}, (_, i) => {
            const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
            return {
              img: this.zsfileCode[pos],
              // video: this.zsvideofileCode[pos],
              video: this.zsVideofileList[pos].code,

              title: this.zstitleList[pos],
              type: 'review'
            };
          });

          // 合并并随机排序（实现撞审素材随机穿插）
          const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          for (let i = combinedMaterials.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          }

          // 构建创意列表
          this.creativeList = combinedMaterials.map(material => {
            const arr = {
              avatarCode: this.txfileCode[0],
              imgsCode: material.img,
              videoCode: material.video,
              title: material.title,
              placeType: this.formLabelAlign3.placeType[0],
              productName: this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ],
              materialNormId: this.formLabelAlign3.placeType[1]
            };

            // 根据媒体类型处理特殊字段
            if (this.formLabelAlign.mediaType === '2') {
              arr.appName = this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ];
              arr.subTitle = material.title;
            }
            arr.virtualPositionId = this.formLabelAlign.mediaType === '1' ? "1,2,13,17" : 12;

            return arr;
          });

          // 更新轮转索引（考虑数组循环）
          this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          // 提交请求
          const payload = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            creativeList: this.creativeList,
            groupId: this.idsList[key].groundId,
            name: this.idsList[key].planName,
            clickMonitorUrl: this.idsList[key].xiaoshuourl,
            viewMonitorUrl: this.idsList[key].baoguangurl,
            adcreativedeeplink: this.idsList[key].adcreativedeeplink,
            username:this.idsList[key].username,
            twoname:this.idsList[key].twoname,

          };
          await this.guanggao(payload);
          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);
        }


        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }
      }
      else if (this.formLabelAlign3.placeType[1]==='75' ||this.formLabelAlign3.placeType[1]==='242'){

        let t=0;

        for (let key in this.idsList){
          if (this.daluan===true){
            this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
          }

          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            dailyBudget:this.formLabelAlign.dailyBudget,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          let parms1={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }

          // if (this.stopAll == true){
          //   this.stopAll = false
          //   return false
          // }
          await this.GetZZData(this.idsList[key].ids,this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids,this.idsList[key].token)
          await this.GetGroupPrice(this.idsList[key].ids,this.idsList[key].token)

          if(this.ePlanId !==''  && this.newplanflag == true){
            let groundData={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              campaignId:this.ePlanId,
              webSiteUrl:this.idsList[key].url,
              id:key,
              startDate:this.startDate,
              ocpxPrice:this.isoldgroupprice?this.oldGroupPrice:new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name:this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)

          }
          else{
            await this.plan(parms)
            let groundData={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              campaignId:this.idsList[key].planId,
              webSiteUrl:this.idsList[key].url,
              id:key,
              startDate:this.startDate,
              ocpxPrice:this.isoldgroupprice?this.oldGroupPrice:new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name:this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)

          }
          let data ={
            token:this.idsList[key].token,
            ids:this.idsList[key].ids,
            groupId:this.idsList[key].groundId,
          }
          await this.PostGroupTime(data)
          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // 生成普通素材队列（图片+视频+标题）
          const normalMaterials = Array.from({length: normalCount}, (_, i) => {
            const pos = (this.currentNormalIndex + i) % this.fileCode.length;
            return {
              img: this.fileCode[pos],
              // video: this.videofileCode[pos],
              video: this.VideofileList[pos].code,
              title: this.formLabelAlign3.title[pos],
              type: 'normal'
            };
          });

          // 生成撞审素材队列（图片+视频+标题）
          const reviewMaterials = Array.from({length: reviewCount}, (_, i) => {
            const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
            return {
              img: this.zsfileCode[pos],
              // video: this.zsvideofileCode[pos],
              video: this.zsVideofileList[pos].code,
              title: this.zstitleList[pos],

              type: 'review'
            };
          });

          // 合并并随机排序（实现撞审素材随机穿插）
          const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          for (let i = combinedMaterials.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          }

          // 构建创意列表
          this.creativeList = combinedMaterials.map(material => {
            const arr = {
              avatarCode: this.txfileCode[0],
              imgsCode: material.img,
              videoCode: material.video,
              title: material.title,
              placeType: this.formLabelAlign3.placeType[0],
              productName: this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ],
              materialNormId: this.formLabelAlign3.placeType[1]
            };

            // 根据媒体类型处理特殊字段
            if (this.formLabelAlign.mediaType === '2') {
              arr.appName = this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ];
              arr.subTitle = material.title;
            }
            arr.virtualPositionId = this.formLabelAlign.mediaType === '1' ? "1,2,13,14,17" : 12;

            return arr;
          });

          // 更新轮转索引（考虑数组循环）
          this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          // 提交请求
          const payload = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            creativeList: this.creativeList,
            groupId: this.idsList[key].groundId,
            name: this.idsList[key].planName,
            clickMonitorUrl: this.idsList[key].xiaoshuourl,
            viewMonitorUrl: this.idsList[key].baoguangurl,
            adcreativedeeplink: this.idsList[key].adcreativedeeplink,
            username:this.idsList[key].username,
            twoname:this.idsList[key].twoname,

          };
          await this.guanggao(payload);
          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);
        }

        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }
      }
      else {
        let t=0;
        for (let key in this.idsList){
          if (this.daluan===true){
            this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
          }

          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            dailyBudget:this.formLabelAlign.dailyBudget,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }


          // if (this.stopAll == true){
          //   this.stopAll = false
          //   return false
          // }
          await this.GetZZData(this.idsList[key].ids,this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids,this.idsList[key].token)
          await this.GetGroupPrice(this.idsList[key].ids,this.idsList[key].token)
          if(this.ePlanId !==''  && this.newplanflag == true){
            let groundData={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              campaignId:this.ePlanId,
              webSiteUrl:this.idsList[key].url,
              id:key,
              startDate:this.startDate,
              ocpxPrice:this.isoldgroupprice?this.oldGroupPrice:new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name:this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)
            let data ={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              groupId:this.idsList[key].groundId,
            }
            console.log(this.idsList)
            await this.PostGroupTime(data)


          }

          else{
            await this.plan(parms)
            let groundData={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              campaignId:this.idsList[key].planId,
              webSiteUrl:this.idsList[key].url,
              id:key,
              startDate:this.startDate,
              ocpxPrice:this.isoldgroupprice?this.oldGroupPrice:new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name:this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
            }
            await this.stopPlan(groundData)
            await this.ground(groundData)
            let data ={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              groupId:this.idsList[key].groundId,
            }
            console.log(this.idsList)
            await this.PostGroupTime(data)
          }

          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          console.log(this.countformData)
          console.log(this.fileCode)
          // 生成普通素材队列（图片+视频+标题）
          const normalMaterials = Array.from({length: normalCount}, (_, i) => {
            const pos = (this.currentNormalIndex + i) % this.fileCode.length;
            return {
              img: this.fileCode[pos],

              title: this.formLabelAlign3.title[pos],
              type: 'normal'
            };
          });

          // 生成撞审素材队列（图片+视频+标题）
          const reviewMaterials = Array.from({length: reviewCount}, (_, i) => {
            const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
            return {
              img: this.zsfileCode[pos],

              title: this.zstitleList[pos],
              type: 'review'
            };
          });

          // 合并并随机排序（实现撞审素材随机穿插）
          const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          for (let i = combinedMaterials.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          }

          // 构建创意列表
          this.creativeList = combinedMaterials.map(material => {
            const arr = {
              avatarCode: this.txfileCode[0],
              imgsCode: material.img,
              videoCode: material.video,
              title: material.title,
              placeType: this.formLabelAlign3.placeType[0],
              productName: this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ],
              materialNormId: this.formLabelAlign3.placeType[1]
            };

            // 根据媒体类型处理特殊字段
            if (this.formLabelAlign.mediaType === '2') {
              arr.appName = this.formLabelAlign3.productNames[
                Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ];
              arr.subTitle = material.title;
            }
            if (this.formLabelAlign.mediaType === '1') {
              arr.virtualPositionId = "1,2,13";
            } else {
              const placeTypeSecond = this.formLabelAlign3.placeType[1];
              const typeIdMap = { '35': 9, '85': 9, '39': 11 };
              // 用逻辑或 || 替代空值合并运算符 ??
              arr.virtualPositionId = typeIdMap[placeTypeSecond] || 12; // 当值不存在时 fallback 到 12
            }

            return arr;
          });

          // 更新轮转索引（考虑数组循环）
          this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          // 提交请求
          const payload = {
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            creativeList: this.creativeList,
            groupId: this.idsList[key].groundId,
            name: this.idsList[key].planName,
            clickMonitorUrl: this.idsList[key].xiaoshuourl,
            viewMonitorUrl: this.idsList[key].baoguangurl,
            adcreativedeeplink: this.idsList[key].adcreativedeeplink,
            username:this.idsList[key].username,
            twoname:this.idsList[key].twoname,
          };
          await this.guanggao(payload);

          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);

        }

        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }


      }



    },
    // async findIds() {
    //   this.idsList = [];
    //   const accountList = this.accounts.split('\n').filter(line => line.trim());
    //
    //   try {
    //     // 并行发送所有请求
    //     const promises = accountList.map(account =>
    //       axios.post('https://test.nbweiou.cn/api/getByIdsName', { "idsname": account })
    //     );
    //
    //     // 等待所有请求完成
    //     const responses = await Promise.all(promises);
    //
    //     // 提取结果（res.data）并合并到 idsList
    //     this.idsList = responses.map(res => res.data[0]);
    //   } catch (error) {
    //     console.error('部分请求失败:', error);
    //   }
    // }

    async findIds(){

      this.idsList=[],
        await axios.post('https://test.nbweiou.cn/api/get_ids',{
          'username':this.username,
          'twoname':this.towName
        }).then(
          async res=>{
            this.idsList=res.data;
          },
        )
    }
    ,
    ro(){
      this.formLabelAlign3.title=[]

    },
    //刷新信息
    async GetRo(){

      let time1 = parseInt(new Date().getTime()) + '';
      console.log(time1)

      await axios.post('https://test.nbweiou.cn/api/get_vivo_user',{
        'username':this.username
      }).then(
        res=>{
          this.two=res.data
          // for (let key in res.data){
          //   this.twoName[key]=res.data[key].twoname
          //   this.towToken[key]=res.data[key].token
          // }
        }
      )
    },
    //停止计划api
    async stopPlan(parms){
      let flag1=0;
      if (this.flag===false){
        flag1=1
      }else {
        flag1=0;
      }

      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids+'',
        {
          "ids": parms.campaignId,
          "startAndStop": flag1
        }).then(res=>{

        //推广计划id id
      })
    },
    // 搭建计划api
    async plan(parms){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      let adtypes=1;
      let names='';
      if (this.idsList[parms.id].url.substr(0, 2)==="ht") {
        adtypes=this.beSelectAdType
        names=parms.name+'_'+time1+'_'+'https_'+this.formLabelAlign.name;

      }else if (this.idsList[parms.id].url.substr(0, 2)==="ha"){
        adtypes=this.beSelectAdType
        names=parms.name+'_'+time1+'_'+'hap_'+this.formLabelAlign.name;

      }

      if (parms.dailyBudget===''){
        parms.dailyBudget=-1
      }else {
        parms.dailyBudget = parms.dailyBudget*100000
      }
      console.log("打印一下计划名字");
      console.log(parms.name);
      console.log(names );

      await axios.post('api/openapi/v1/ad/campaign/add?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids+'',

        {
          name:names,
          adType:adtypes,
          mediaType:parms.mediaType,
          dailyBudget:parms.dailyBudget,
          optimizeFlag:0,
          campaignType:0,
        }).then(res=>{
        if (res.data.code===70111){
          this.$notify({
            title: '创建失败',
            message: res.data.message,
            type: 'error'
          });
        }
        this.idsList[parms.id].planId=res.data.data.id
        console.log(res.data);
        //推广计划id id
      })

    },
    // 搭建广告组api
    async ground(parms){

      let price=0;
      // let price1=30000;
      if (this.formLabelAlign.mediaType==='1'){
        price=999000
      }else {
        price=10000
      }
      let map = {};
      if (this.flag1===true){
        map["customList"]=this.customListrqb;

      }
      if (this.flag2===true){
        map["excludeCustomList"]=this.customListrqbpc;

      }

      // this.erjihangye[0] this.erjihangye[1]
      // this.zzIdList中的子对象industry1和 industry2值
      // 配对后根据adType的值去：快应用选英文的产品名 否则就选网址
      // this.beSelectAdType 被选中的广告类型
      this.zjerji = this.erjihangye

      if (this.zjerji[0] && typeof this.zjerji[0] === 'string') {
        this.zjerji[0]= this.zjerji[0].replace(/["']/g, ''); // 去除双引号或单引号
      }

      if (this.zjerji[1] && typeof this.zjerji[1] === 'string') {
        this.zjerji[1]= this.zjerji[1].replace(/["']/g, ''); // 去除双引号或单引号
      }
      console.log(this.zzIdList)
      console.log(this.beSelectAdType)
      console.log(this.zjerji)
// 1. 找到符合条件的对象
      let targetObject = this.zzIdList.find(obj => obj.industry1 === Number(this.zjerji[0] )&& obj.industry2 === Number(this.zjerji[1] ));

// 2. 如果找到了目标对象
      if (targetObject) {
        let advertiseQualificationList = targetObject.advertiseQualificationList;

        // 3. 根据beSelectAdType的值判断
        this.advertiseQualificationId = advertiseQualificationList.filter(item => {
          console.log(item)
          if (this.beSelectAdType === 8) {
            // 当 beSelectAdType 为 8 时，检查 productName 是否包含字母、数字和点号
            // return /^[A-Za-z0-9.]+$/.test(item.productName);
            return /^com/.test(item.productName);
          } else {

            // 当 beSelectAdType 不为 8 时，检查 productName 是否不完全是字母
            return !/^com/.test(item.productName);
          }

        }).map(item => item.advertiseQualificationId); // 获取advertiseQualificationId

        console.log( this.advertiseQualificationId); // 输出结果
      } else {
        console.log("没有找到符合条件的对象");
      }


      let region={
        'regionCodeList'  :this.beSelectMap.map.region.regionCodeList,
        'stayType':1
      }
      map["sexList"]=this.sexList;
      map["region"] = region;
      // map["customList"]=this.customList;
      map["ageList"]=this.ageIdList;
      if(this.selectedPrices.length !== 9){
        map["phonePriceSet"]=this.selectedPrices;
      }

      if(this.selectedVersions.length !== 11){
        map["androidVersionSet"]=this.selectedVersions;
      }

      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      if(this.idsList[parms.id].url.substr(0,2)==="ht"){

// 判断this.beSelectCategory是否为空数组来决定是否添加属性
        const data = {
          // wechatFollow:1,
          audienceInfo:map,

          campaignId:parms.campaignId,
          webSiteUrl:parms.webSiteUrl,
          startDate:this.getNowFormatDate(),
          endDate:'2038-01-19',
          h5Type:2,
          scheduleTime:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType:3,
          price:price,
          cvType:this.formLabelAlign1.cvType,
          ocpxPrice:parms.ocpxPrice,
          name:parms.name+'_'+time1+'_'+this.formLabelAlign.name,
          dailyBudget:-1,
          spentType:1,
          //channelId:parms.channelId,
          biddingStrategy:0,
          builtInRpkDeepLink:parms.builtInRpkDeepLink,
        }

        if (this.isguanz){
          data.wechatFollow= 1
        }else{
          data.wechatFollow= 0
        }
        if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
          data.industry1=this.zjerji[0]
          data.industry2=this.zjerji[1]
        }else{
          data.advertiseQualificationId=this.advertiseQualificationId[0]
        }
        // 如果 this.beSelectCategory 不是空数组，添加 categoryId 属性
        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa ={
            productId :this.beSelectCategory.id,
            productName : this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId:this.beSelectCategory.productLibraryId,
            categories:[
              {
                categoryId:this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }
        await axios.post('api/openapi/v1/ad/group/add?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids,
          data).then(res=>{
          if (res.data.code===70111){
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
          }
          console.log(res);
          this.idsList[parms.id].groundId=res.data.data
          //广告组ID

        })
      }
      else if(this.idsList[parms.id].url.substr(0, 2)==="ha"){
        const data = {
          audienceInfo:map,
          // industry1:2100023,
          // industry2:2220187,
          // advertiseQualificationId: this.advertiseQualificationId[0],
          campaignId:parms.campaignId,
          rpkDeepLink:parms.webSiteUrl,
          startDate:this.getNowFormatDate(),
          endDate:'2038-01-19',
          scheduleTime:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType:3,
          price:price,

          cvType:this.formLabelAlign1.cvType,
          ocpxPrice:parms.ocpxPrice,
          name:parms.name+'_'+time1+'_'+this.formLabelAlign.name,
          dailyBudget:-1,
          spentType:1,
          //channelId:parms.channelId,
          biddingStrategy:0
        }

        if (this.isguanz){
          data.wechatFollow= 1
        }else{
          data.wechatFollow= 0
        }
        if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
          data.industry1=this.zjerji[0]
          data.industry2=this.zjerji[1]
        }else{
          data.advertiseQualificationId=this.advertiseQualificationId[0]
        }
        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa ={
            productId :this.beSelectCategory.id,
            productName : this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId:this.beSelectCategory.productLibraryId,
            categories:[
              {
                categoryId:this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }


        await axios.post('api/openapi/v1/ad/group/add?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids,
          data).then(res=>{
          if (res.data.code===70111){
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
          }
          console.log(res);
          this.idsList[parms.id].groundId=res.data.data
          //广告组ID

        })
      }
    },
    // 创建广告api
    async guanggao(parms){
      // console.log('-----------------------')
      // console.log(parms.creativeList)
      // adcreativedeeplink:this.idsList[key].adcreativedeeplink
      const data = {   creativeList:parms.creativeList,
        groupId:parms.groupId,
        name:parms.name+'_'+this.formLabelAlign.name,
        clickMonitorUrl:parms.clickMonitorUrl,
        viewMonitorUrl:parms.viewMonitorUrl
      }

      if (parms.adcreativedeeplink !== '' || parms.adcreativedeeplink !== undefined ||parms.adcreativedeeplink !== null ) {
        data.deepLink = parms.adcreativedeeplink
      }
// 获取当前时间
      const today = new Date();

// 获取年、月、日（注意月份要 +1）
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 补零
      const day = String(today.getDate()).padStart(2, '0');        // 补零

// 拼接成目标格式
      const formattedDate = `${year}-${month}-${day}`;
      // console.log(formattedDate); // 输出示例：2025-02-27

      // username: params.username
      // twoname:params.twoname
      // num:   parms.creativeList.length
      // batchtime: formattedDate



      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/advertisement/add/cu' +
        'stomize/adCreative?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids+'',
        data).then(res=>{
        if (res.data.code===70111){
          const str = res.data.message;
          const startIndex = str.indexOf("[") + 1;
          const endIndex = str.indexOf("]");
          const code = str.substring(startIndex, endIndex);
          // const fileCode = ["12345678", "98765432"];
          // const videofileCode = ["90007642"];

          const indexFile = this.fileCode.indexOf(code);
          const indexVideo = this.videofileCode.indexOf(code);

          if (indexFile !== -1) {
            this.$notify({
              title: '创建失败',
              message: `第${indexFile + 1}张图片错误`,
              type: 'error'
            });
          } else if (indexVideo !== -1) {
            this.$notify({
              title: '创建失败',
              message: `第${indexVideo + 1}张视频错误`,
              type: 'error'
            });
          } else {
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
          }

        }
        console.log(res.data);
        //广告组ID

      })
    },
    //获取时间方法
    //获取当前日期函数
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}-${month}-${strDate}`
    },
    //图片上传api

    //修改日期Api
    async PostGroupTime(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.ids,
        {
          "ids":pams.groupId,
          "scheduleTime":this.time_list,
        }).then(resp=>{
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放时段失败，请检查时段是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放时段成功',
            type: 'success',
            position: 'bottom-left'
          });
          this.dialog=false
        }

      })


    },
    change(){
      console.log(this.towName)
    },
    onChange(a, fileList) {
      this.tpchange = true
      this.showVue2 = true
    },
    txonChange(a, fileList) {
      this.txchange = true
      this.showVue2 = true

    },
    zsonChange() {
      this.zstpchange = true
      this.showVue2 = true
    },
    onChange2() {
      this.spchange = true
      this.showVue2 = true
    },
    zsonChange2() {
      this.zsspchange = true
      this.showVue2 = true
    },
    // 处理删除
    handleRemove: function(file) {
      const tp = this.fileList.findIndex(function(item) {
        return item.uid === file.uid;
      });
      if (tp !== -1) {
        this.fileList.splice(tp, 1);
        this.fileCode.slice(tp,1)
      }
    },

    zshandleRemove: function(file) {
      var zstp = this.zsfileList.findIndex(function(item) {
        return item.uid === file.uid;
      });
      if (zstp !== -1) {
        this.zsfileList.splice(zstp, 1);
        this.zsfileCode.slice(zstp,1)
      }
    },

    txhandleRemove(file, fileList) {
      // console.log(file, fileList);
    },

    // 处理预览
    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = 'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath;
      this.dialogVisible = true;
    },
    zshandlePictureCardPreview: function(file) {
      this.dialogImageUrl = 'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath;
      this.dialogVisible = true;
    },

    txhandlePictureCardPreview(file) {
      console.log(file)
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },

    handleRemove2(targetCode) {

      this.VideofileList = this.VideofileList.filter(
        item => item.code !== targetCode
      );
      // this.videofileCode = this.videofileCode.filter(
      //   item => item.code !== targetCode
      // );
    },

    zshandleRemove2(targetCode) {
      this.zsVideofileList = this.zsVideofileList.filter(
        item => item.code !== targetCode
      );
    },
    handlePictureCardPreview2(file) {


    },
    zshandlePictureCardPreview2(file) {


    },
    clearFiles1(file,fileList){
      this.$refs.upload.clearFiles()
      this.$refs.upload12.clearFiles()

    },
  },
  created(){
    this.fetchHdCookieData()

    //自动加载indexs方法
    axios.get('https://test.nbweiou.cn/api/find_list_name',{
    }).then(
      res=>{
        this.listname=res.data
        console.log(this.listname)
      }
    )
  }
}
</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}
.el-form-item{
  margin-bottom:7px;
  margin-top: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}


.box-card1 {
  position: absolute;
;
  top: 0px;
  bottom: 0;
  left: 0;
  right: 0;
  margin:0 auto;
  width: 50%;
}
.box-card2 {
  position: absolute;
  top: 550px;
  bottom: 0;
  left: 0;
  right: 0;
  margin:0 auto;
  width: 40%;
}
.box-cardf1s {
  position: absolute;
  top: 1050px;
  bottom: 0;
  left: 0px;
  right: 0px;
  margin:0 auto;
  width: 40%;
}
.box-card {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed; bottom: 35px;right: 30px;
  width: 40%;
}
.box-cards {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed; top: 20px;left: 30px;
  width: 20%;
}
.jdt{
  margin:0 auto;
}
.el-icon-plus{
  width: 20px;
  height: 20px;
}
.test{
  width: 20px;
  height: 20px;
}

</style>



<style scoped>
.time-range-container {

}

.time-range-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.separator {
  margin: 0 10px;
}

.el-time-select {
  width: 120px;
}

.result {
  margin-top: 20px;
  font-family: monospace;
  word-break: break-all;
}
</style>



<style scoped>
.switch-group {
  display: flex;
  align-items: center;
  gap: 24px; /* 控制开关之间的间距 */
}

.switch-item {
  display: flex;
  align-items: center;
  gap: 8px; /* 控制开关与文字的间距 */
}

.switch-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

/* 可选：添加鼠标悬停效果 */
.switch-item:hover .switch-label {
  color: #409EFF;
}
/* 自定义样式 */
.upload-trigger {
  display: inline-block;
  padding: 8px;
  cursor: pointer;
}

/* 隐藏默认的上传按钮 */
.el-upload--picture-card {
  display: none !important;
}

.file-item {
  position: relative;
  width: 100%;
  height: 100%;
}

.el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>




<!-- 在 Vue2 组件内部需要添加如下样式 -->
<!-- Vue2.vue -->




// WEBPACK FOOTER //
// src/components/login/vivopida.vue